// Shared coordinate helpers for the viz components. Every percent value a viz
// writes into markup (`left`, `width`, `height`, `--heat`) goes through pct(),
// so float noise and non-finite input can never reach the DOM.

/** Clamp a 0–1 fraction. Non-finite input (NaN, ±Infinity) becomes 0. */
export function clamp01(n: number): number {
  return Number.isFinite(n) ? Math.min(1, Math.max(0, n)) : 0
}

/**
 * Format a 0–100 percent coordinate for CSS: clamped to 0–100 (non-finite
 * becomes 0) and rounded to two decimals, so (0.7 − 0.5) / 0.25 × 100 prints
 * "80%" rather than "79.99999999999997%".
 */
export function pct(n: number): string {
  const clamped = Number.isFinite(n) ? Math.min(100, Math.max(0, n)) : 0
  return `${Math.round(clamped * 100) / 100}%`
}
